//
//
//
//
//
//

import gameCont from '../game/index.vue'
export default {
  name: "chess",
  components: {gameCont},
  data() {
    return {
      gameTypeCode: '6',
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/build922/views/home/pages-6.vue